//frontend/src/dropdownMap/2Act2_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    14: "BeneficiaryEntityCategory",
    16: "Gender",
    19: "MSPMember",
    20: "BusinessPlan",
    21: "SUNBNMember",
    22: "ContractedWithOthers",
    25: "TypesOfEnterprises",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    BeneficiaryEntityCategory: {
        internal: ["msme", "sme", "apg", "ac"],
        LA: { "msme": "MSME", "sme": "SME", "apg": "APG", "ac": "AC" },
        EN: { "msme": "MSME", "sme": "SME", "apg": "APG", "ac": "AC" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    MSPMember: {
        internal: ["msp_no", "msp_yes"],
        LA: { "msp_no": "No", "msp_yes": "Yes" },
        EN: { "msp_no": "No", "msp_yes": "Yes" }
    },

    BusinessPlan: {
        internal: ["plan_no", "plan_yes"],
        LA: { "plan_no": "No", "plan_yes": "Yes" },
        EN: { "plan_no": "No", "plan_yes": "Yes" }
    },

    SUNBNMember: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    ContractedWithOthers: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    TypesOfEnterprises: {
        internal: ["_", "__1", "__2", "__3", "__4", "_buying"],
        LA: {
            "_": "ການຜະລິດ",
            "__1": "ປຸງແຕ່ງ",
            "__2": "ສະໜອງປັດໃຈ",
            "__3": "ຂົນສົ່ງ",
            "__4": "ຂາຍຍ່ອຍ",
            "_buying": "ເກັບຊື້"
        },
        EN: {
            "_": "Production",
            "__1": "Processing",
            "__2": "Provision of service",
            "__3": "Logistics",
            "__4": "Retail",
            "_buying": "Product collector"
        }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
